import { TargetActionTypes } from '../constants/ApiConstants';

const initialState = {
    loading: false,
    targetList: null,
    targetListDetails: null,
    deleted_targetList: null,
    saved_targetList: null,
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case TargetActionTypes.get_targetList.REQUEST:
            return {
                ...state,
                loading: true,
                targetList: null
            };
        case TargetActionTypes.get_targetList.SUCCESS:
            return {
                ...state,
                loading: false,
                targetList: payload
            };
        case TargetActionTypes.get_targetDetails.REQUEST:
            return {
                ...state,
                loading: true,
                targetListDetails: null
            };
        case TargetActionTypes.get_targetDetails.SUCCESS:
            return {
                ...state,
                loading: false,
                targetListDetails: payload
            };
        case TargetActionTypes.post_target.REQUEST:
            return {
                ...state,
                loading: true,
                saved_targetList: null
            };
        case TargetActionTypes.post_target.SUCCESS:
            return {
                ...state,
                loading: false,
                saved_targetList: payload
            };
        case TargetActionTypes.delete_target.REQUEST:
            return {
                ...state,
                loading: true,
                deleted_targetList: null
            };
        case TargetActionTypes.delete_target.SUCCESS:
            return {
                ...state,
                loading: false,
                deleted_targetList: payload
            };
        default:
            return state;
    }
} 


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/target/reducers/targetReducer.js